import { useEffect } from 'react';

import { Button, Dialog, DialogContent, DialogTitle, FormControl, Grid } from '@mui/material';
import { SelectionAutocomplete } from 'components/Autocomplete/SelectionAutocomplete';
import {
    getAssetsPicklist,
    getZonesPicklist,
    resetItemsPicklistStatus,
    resetZonesPicklistStatus,
    selectAssetsPicklist,
    selectAssetsPicklistLoadingStatus,
    selectZonesPicklist,
    selectZonesPicklistLoadingStatus,
} from 'features/picklists/pickListsSlice';
import { Field, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

const ZonesLoader = ({ assetId }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!assetId) {
            return;
        }

        dispatch(
            getZonesPicklist({
                assetId,
            })
        );
    }, [assetId, dispatch]);

    return null;
};

const HotspotPanoDataForm = ({ valuesData, setFieldValue, setOpenHotspotOptionForm, hotspotOptions }) => {
    const dispatch = useDispatch();

    const INIT_VALUES = {
        asset_id: valuesData?.asset_id ?? null,
        zone_id: valuesData?.zone_id ?? null,
    };

    const handleSubmit = (data) => {
        setOpenHotspotOptionForm(false);

        const consolidatedHotspots =
            Array.isArray(hotspotOptions) && hotspotOptions.length > 0
                ? hotspotOptions.map((ho) => ({
                      ...ho,
                      asset_id: data?.asset_id,
                      zone_id: data?.zone_id,
                  }))
                : [
                      {
                          action: {
                              id: '',
                              type: 'node',
                          },
                          hotspot_id: Number(hotspotOptions?.length),
                          asset_id: data.asset_id,
                          zone_id: data.zone_id,
                          item_id: null,
                          option_text: uuidv4(),
                          answer_value: '',
                      },
                  ];

        setFieldValue('hotspot_options', consolidatedHotspots);
        setFieldValue('hotspot_target_combinations', []);
        dispatch(resetItemsPicklistStatus());
    };

    return (
        <Dialog open={true} fullWidth maxWidth="sm">
            <DialogTitle>Select Asset & Zone</DialogTitle>
            <DialogContent
                style={{
                    paddingTop: '5px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Formik initialValues={INIT_VALUES} onSubmit={(values) => handleSubmit(values)}>
                            {({ values }) => (
                                <Form>
                                    <FormControl fullWidth style={{ marginTop: '10px' }}>
                                        <Field name="asset_id">
                                            {({ field: { value }, form: { setFieldValue } }) => (
                                                <SelectionAutocomplete
                                                    title="Asset"
                                                    keyProperty="asset_id"
                                                    nameProperty="display_name"
                                                    entityIds={value}
                                                    setEntityIds={setFieldValue}
                                                    onCustomChange={() => {
                                                        dispatch(resetZonesPicklistStatus());
                                                        setFieldValue('zone_id', null);
                                                    }}
                                                    entitySelector={selectAssetsPicklist}
                                                    fetchEntityPage={getAssetsPicklist}
                                                    formField="asset_id"
                                                    multiSelection={false}
                                                    entityStatusSelector={selectAssetsPicklistLoadingStatus}
                                                />
                                            )}
                                        </Field>
                                    </FormControl>

                                    {!!values.asset_id && (
                                        <>
                                            <ZonesLoader assetId={values.asset_id} />
                                            <FormControl fullWidth style={{ marginTop: '10px' }}>
                                                <Field name="zone_id">
                                                    {({ field: { value }, form: { setFieldValue } }) => (
                                                        <SelectionAutocomplete
                                                            title="Zone"
                                                            keyProperty="zone_id"
                                                            nameProperty="display_name"
                                                            entityIds={value}
                                                            setEntityIds={setFieldValue}
                                                            onCustomChange={() => {
                                                                dispatch(resetItemsPicklistStatus());
                                                            }}
                                                            entitySelector={selectZonesPicklist}
                                                            fetchEntityPage={getZonesPicklist}
                                                            formField={'zone_id'}
                                                            multiSelection={false}
                                                            entityStatusSelector={selectZonesPicklistLoadingStatus}
                                                            fetchParams={{
                                                                assetId: values?.asset_id,
                                                            }}
                                                        />
                                                    )}
                                                </Field>
                                            </FormControl>
                                        </>
                                    )}

                                    <div
                                        style={{
                                            justifyContent: 'end',
                                            display: 'flex',
                                            marginTop: '25px',
                                        }}
                                    >
                                        <Button onClick={() => setOpenHotspotOptionForm(false)}>Cancel</Button>

                                        <Button type="submit">Save</Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default HotspotPanoDataForm;
